import { useCallback, useEffect, useRef, useState } from 'react';

/** Autoplaying, muted, looping background video with a manual play/pause control. */
function LocalVideo({ src, poster, label }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);

  const startVideo = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const playRequest = video.play();
    if (playRequest) playRequest.catch(() => setPlaying(false));
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    startVideo();
    const resumeWhenVisible = () => {
      if (!document.hidden && video.paused) startVideo();
    };
    video.addEventListener('loadeddata', startVideo);
    video.addEventListener('canplay', startVideo);
    document.addEventListener('visibilitychange', resumeWhenVisible);

    return () => {
      video.removeEventListener('loadeddata', startVideo);
      video.removeEventListener('canplay', startVideo);
      document.removeEventListener('visibilitychange', resumeWhenVisible);
    };
  }, [src, startVideo]);

  return (
    <div className="react-local-video">
      <video ref={videoRef} src={src} poster={poster} autoPlay muted loop playsInline preload="auto" aria-label={label}
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} />
      <button className="react-video-control" type="button"
        aria-label={playing ? `Pause ${label}` : `Play ${label}`}
        onClick={(event) => {
          const video = event.currentTarget.previousElementSibling;
          if (video.paused) video.play(); else video.pause();
        }}>
        {playing ? 'Ⅱ' : '▶'}
      </button>
    </div>
  );
}

export default LocalVideo;
